
// ############# Route ###########
export const ROUTE_PATIENT_REG = '/patient-registration';
export const PRIVACY_POLICY = '/privacy-policy';
export const ROUTE_NURSING_STAFF_REG = '/nursing-registration';
export const ROUTE_FAMILY_REG = '/family-registration';
export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGIN_PATIENT = '/patient-login';
export const ROUTE_RESET_PASSWORD           = '/user/verify-email'; 
export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_NURSING_STAFF_LIST = '/facility-stafflist';
export const ROUTE_CLIENT_LIST = '/clientlist';
export const ROUTE_FACILITY_LIST = '/facilitylist';
export const ROUTE_PROVIDER_LIST = '/providerlist';
export const ROUTE_PATIENT_LIST = '/patientlist';
export const ROUTE_ASSOCIATE_USERLIST = '/associate-userlist';
export const ROUTE_TIMESHEET = '/timesheet';
export const ROUTE_NOTIFICATION_LIST = '/notificationlist';
export const ROUTE_ROLE_PERMISSION = '/roles-and-permission';
export const ROUTE_PROFILE = '/profile';
export const ROUTE_AUTO_REPLY = '/auto-reply';
export const ROUTE_MESSAGE_TEMPLATE = '/message-template';
export const ROUTE_TRIAGE_QUEUE = '/triage-queue';


export const ROUTE_404                      = "*"; 


